module.exports = __webpack_public_path__ + "static/media/office01.a6f79bc6.jpg";